import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr16 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За защита на хора, работещи на открито при гръмотевични бури
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. При поява на гръмотевична буря </b>веднага се прекратява работата в полето и на
        открито, като служителите се подслоняват в закрито помещение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Когато наблизо няма </b>помещение и служителите бъдат застигнати по пътя от
        гръмотевична буря, да не тичат, а незабавно спокойно да залегнат между две дървета, два
        храста или между два големи камъка, като дърветата, храстите и камъните отстоят на 15- 20
        метра един от друг. Ако не намерят такова прикритие, не бива да вървят повече, а да легнат
        на канавка, яма, земна вдлъбнатина или друго такова убежище, макар че ще бъдат изложени на
        дъжд, и там да изчакат преминаването на гръмотевичната буря.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Да не се търси убежище под дървета </b>и особено под единични дървета.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. През време на гръмотевиците</b> работникът трябва навреме да се освободи от метални
        предмети /кирки, лопати, брадви, триони, вили и други/, ако носи със себе си да ги остави
        далеч от мястото на прикритието.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. През време на гръмотевичната буря </b>в никакъв случай не бива да се доближава до
        телефонни и електрически стълбове, пилони и други не по-малко от 20-25 метра, особено когато
        те са железни и на открити места. Опасно е да се доближава до крайпътни чешми, кладенчета,
        изворчета и да търси убежище близо до бреговете на реки и места с много подпочвени води,
        защото това са участъци, който често стават прицел на гръмотевични удари.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. При гръмотевици не трябва </b>да се върви по връх или било на малки и големи хълмове.
        Също така да не се слиза в долове, особено, в онези, в които протичат малки реки или потоци.
        По- безопасно е да се търси прикритие по средата на хълма, а ако няма такова, да се залегне
        на земята.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. Когато група работници </b>бъдат застигнати от гръмотевична буря и са близо до
        електрически далекопроводи, въжени линии, железопътни линии, незабавно да се разпръснат и
        залегнат на различни места на разстояние най-малко 8-10 метра един от друг, тъй като при
        удар на гръм върху един от тях вследствие на появило се по земната повърхност напрежение при
        движението могат да бъдат поразени и други, ако са наблизо.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr16;
